import React from 'react';
import './feature.css';

const  Feature = ({ title, text }) => {
    return (
        <div className="taasa__features-container__feature">
            <div className="taasa__features-container__feature-title">
                <div />
                <h1>{title}</h1>
            </div>
            <div className="taasa__features-container_feature-text">
                <p className="taasa__features-container__feature-text">{text}</p>
            </div>
        </div>             

    )
}

export default Feature